import { ArtistAnalyticsState } from './state';
import { artistAnalyticsInitialState } from './initial-state';
import { ArtistAnalyticsActions } from './action-creators';
import * as actions from './actions';
import { AnalyticsQueryTypes } from '@services/analytics/types/analytics-query-enum';

export const artistAnalyticsReducer = (
  state: ArtistAnalyticsState = artistAnalyticsInitialState,
  action: ArtistAnalyticsActions
): ArtistAnalyticsState => {
  switch (action.type) {
    case actions.GET_ARTIST_ANALYTICS_SUCCESS: {
      const { streams, downloads, saves, listeners, ...otherData } = state.data;
      const allAnalyticsData = state.data;
      const { timeseries, change, percentChange } = state.lastMonthAnalytics;

      switch (action.queryDataType.toLowerCase()) {
        case AnalyticsQueryTypes.ENGAGEMENT:
          if (action.results.streams.timeseries.length === 0) {
            return {
              ...state,
              isExample: true,
            };
          }
          return {
            ...state,
            isExample: false,
            lastMonthAnalytics:
              state.filters.days === '30'
                ? {
                    change,
                    percentChange,
                    timeseries: action.results.streams.timeseries,
                  }
                : state.lastMonthAnalytics,
            data: {
              ...otherData,
              streams: {
                ...streams,
                timeseries: action.results.streams.timeseries,
              },
              saves: {
                ...saves,
                timeseries: action.results.saves.timeseries,
              },
              downloads: {
                ...downloads,
                timeseries: action.results.downloads.timeseries,
              },
              listeners: {
                ...listeners,
                timeseries: action.results.listeners.timeseries,
              },
            },
          };

        case AnalyticsQueryTypes.COUNTS:
          if (state.isExample && !action.results.streams.aggregatedCount) {
            return state;
          }
          return {
            ...state,
            lastMonthAnalytics:
              state.filters.days === '30'
                ? {
                    timeseries,
                    change: action.results.streams.aggregatedCount,
                    percentChange: action.results.streams.lastPercentChange,
                  }
                : state.lastMonthAnalytics,
            data: {
              ...otherData,
              streams: {
                ...streams,
                aggregatedCount: action.results.streams.aggregatedCount,
                lastPercentChange: action.results.streams.lastPercentChange,
              },
              saves: {
                ...saves,
                aggregatedCount: action.results.saves.aggregatedCount,
                lastPercentChange: action.results.saves.lastPercentChange,
              },
              downloads: {
                ...downloads,
                aggregatedCount: action.results.downloads.aggregatedCount,
                lastPercentChange: action.results.downloads.lastPercentChange,
              },
              listeners: {
                ...listeners,
                aggregatedCount: action.results.listeners.aggregatedCount,
                lastPercentChange: action.results.listeners.lastPercentChange,
              },
            },
          };

        case AnalyticsQueryTypes.AGE:
          if (state.isExample && action.results.ageRange?.length === 0) {
            return state;
          }
          return {
            ...state,
            data: {
              ...allAnalyticsData,
              ageRange: action.results.ageRange,
            },
          };

        case AnalyticsQueryTypes.DSPS:
          if (state.isExample && action.results.topDsps.length === 0) {
            return state;
          }
          return {
            ...state,
            data: {
              ...allAnalyticsData,
              topDsps: action.results.topDsps,
            },
          };

        case AnalyticsQueryTypes.GENDER: {
          if (state.isExample && action.results.gender.length === 0) {
            return state;
          }
          return {
            ...state,
            data: {
              ...allAnalyticsData,
              gender: action.results.gender,
            },
          };
        }

        case AnalyticsQueryTypes.SONGS: {
          if (state.isExample && action.results.topSongs.length === 0) {
            return state;
          }
          return {
            ...state,
            data: {
              ...allAnalyticsData,
              topSongs: action.results.topSongs,
            },
          };
        }

        case AnalyticsQueryTypes.LOCATIONS: {
          if (state.isExample && action.results.topLocations.length === 0) {
            return state;
          }
          return {
            ...state,
            data: {
              ...allAnalyticsData,
              topLocations: action.results.topLocations,
            },
          };
        }

        default:
          return state;
      }
    }

    case actions.UPDATE_TIMEFRAME: {
      return {
        ...state,
        timeframe: {
          ...state.timeframe,
          start: action.start,
          end: action.end,
        },
      };
    }

    case actions.RESET_ANALYTICS: {
      return {
        ...artistAnalyticsInitialState,
        timeframe: {
          ...artistAnalyticsInitialState.timeframe,
        },
      };
    }

    case actions.UPDATE_FIELD: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.field]: action.value,
        },
      };
    }

    default: {
      return { ...state };
    }
  }
};
